import React from "react";
import { Card, CardBody, CardTitle, CardText } from "reactstrap";

const PaiementCard = ({ title, data }) => {
  return (
    <>
      <CardTitle className="h5" style={{ color: "#555b21" }}>
        {title}
      </CardTitle>
      <Card className="shadow-sm">
        <CardBody>
          {data.map((method, index) => (
            <div key={index} className="d-flex flex-column mb-2">
              <h6>{method.text_top}</h6>
              {method.text_bottom && (
                <small
                  dangerouslySetInnerHTML={{ __html: method.text_bottom }}
                  className=""
                />
              )}
            </div>
          ))}
        </CardBody>
      </Card>
    </>
  );
};

export default PaiementCard;
